<section class="email-support" data-testid="email-support-section">
  <goab-text tag="h1" size="heading-xl" mt="xl" mb="s">
    Email the support team
  </goab-text>

  <goab-text tag="p" size="body-m" mt="l" mb="none">
    If you still need help, please email
    <a class="email-support__link" [attr.href]="emailHref">
      alss.alacapacity&#64;gov.ab.ca
      <goab-icon type="open" size="small" [opacity]="1"></goab-icon>
    </a>
  </goab-text>

  <goab-text tag="p" size="body-m" mt="none" mb="s">
    Please include these details for faster response:
  </goab-text>

  <ol class="email-support__details" data-testid="email-support-details-list">
    <li>
      <goab-text tag="span" size="body-m" mt="none" mb="none">
        Your name
      </goab-text>
    </li>
    <li>
      <goab-text tag="span" size="body-m" mt="none" mb="none">
        Facility
      </goab-text>
    </li>
    <li>
      <goab-text tag="span" size="body-m" mt="none" mb="none">
        Facility address
      </goab-text>
    </li>
    <li>
      <goab-text tag="span" size="body-m" mt="none" mb="none">
        Describe your issue
      </goab-text>
    </li>
  </ol>

  <goab-text tag="h2" size="heading-xs" mt="xl" mb="2xs">
    Timelines for responses
  </goab-text>
  <goab-text tag="p" size="body-m" mt="none" mb="xl">
    Email will be responded to within one to two business days. Account changes
    or requests require two business days to complete.
  </goab-text>

  <goab-text tag="h2" size="heading-xs" mt="none" mb="none">
    About requests to change facility details
  </goab-text>
  <goab-text tag="p" size="body-m" mt="none" mb="none">
    Changes to facility details (i.e., changes in the number of funded spaces,
    change to official site contact, facility name etc.) will be referred to
    Assisted Living and Social Services Continuing Care Licensing Office to
    approve any changes through standard processes.
  </goab-text>
  <goab-text tag="p" size="body-m" mt="l" mb="3xl">
    You may be asked to submit additional documentation to the Continuing Care
    Licensing Office depending on the nature of the inquiry. These may include
    an updated Notice to Director form or a Duty to Notify form. The Continuing
    Care Licensing Office will follow up on these inquiries through their usual
    processes.
  </goab-text>
</section>
